import { SimpleTag } from './Tag';

export default interface Flag extends SimpleTag {
  userAssignable: boolean;
  type: FlagTypeEnum;
}

export type CourseFlag = Flag & {
  name: ProjectCourseFlagEnum;
};

export enum FlagTypeEnum {
  GENERAL = 'GENERAL',
  FINALIST = 'FINALIST',
}
export enum ProjectCourseFlagEnum {
  CTRL_QUICK = 'CTRL_QUICK',
  CTRL_KIDS = 'CTRL_KIDS',
  CTRL_TEENS = 'CTRL_TEENS',
  CTRL_YOUNG = 'CTRL_YOUNG',
  CTRL_PRO = 'CTRL_PRO',
}
